import styled, { css } from "styled-components";
import { FlexMixin, FontMixin } from "../../../../styles/common/mixins/helpers.styled.js";
import CheckBoxStyles from "./themes/index.js";
export const CheckboxWrapper = styled.div.withConfig({
    displayName: "styled__CheckboxWrapper",
    componentId: "sc-71e974be-0"
})`
	/* .checkbox-rxjs */
	${FlexMixin({
    align: 'center'
})}
	position: relative;
	user-select: none;
	opacity: 1;
	transition: all 0.2s linear;
	width: 100%;
`;
export const CheckboxInput = styled.input.withConfig({
    displayName: "styled__CheckboxInput",
    componentId: "sc-71e974be-1"
})`
	/* .checkbox-rxjs input */
	${CheckboxWrapper} & {
		background-color: ${(props)=>props.theme.colors.white.base};
		border: none;
		border-radius: 4px;
		cursor: pointer;
		height: 20px;
		margin-right: 8px;
		width: 20px;
		visibility: hidden;
	}
`;
export const CheckboxLabel = styled.label.withConfig({
    displayName: "styled__CheckboxLabel",
    componentId: "sc-71e974be-2"
})`
	width: 100%;
	${FlexMixin({
    align: 'center',
    justify: 'space-between'
})}

	cursor: pointer;
	color: ${(props)=>props.theme.colors.grays.darker};
	${FontMixin({
    size: 'medium',
    height: 'medium',
    weight: 'light'
})}

	&::before {
		border: 1px solid ${(props)=>props.theme.colors.grays.base};
		background-color: ${(props)=>props.theme.colors.white.base};
		border-radius: 4px;
		content: '';
		height: 20px;
		left: 0;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		width: 20px;
	}

	${({ checked  })=>checked ? css`
					${CheckboxInput}:checked+&::after {
						border-left: transparent;
						border-left-style: solid;
						border-top: 0;
						border-left-width: 2px;
						border-bottom: 2px solid ${(props)=>props.theme.colors.primary.light};
						border-right: 2px solid ${(props)=>props.theme.colors.primary.light};
						border-top-width: 2px;
						content: '';
						height: 12px;
						left: 7px;
						position: absolute;
						top: calc(50% - 6px);
						transform: rotate(40deg) translateX(-1px);
						width: 6px;
					}
			  ` : ''}

	${({ theme , $hasError  })=>$hasError ? `
		color: ${theme.colors.status.error};
	` : ''}

${({ theme  })=>CheckBoxStyles[theme.id]?.CheckBoxLabel?.()}
`;
export const CheckboxLabelCount = styled.span.withConfig({
    displayName: "styled__CheckboxLabelCount",
    componentId: "sc-71e974be-3"
})`
	/* .main-results-cru__count */
	border-radius: 8px;
	padding: 2px 6px;
	background-color: ${(props)=>props.theme.colors.grays.lighter};
	color: ${(props)=>props.theme.colors.grays.dark};
	${FontMixin({
    size: 'small',
    height: 'base',
    weight: 'light'
})}
	margin-left: 8px;
	float: right;
	min-width: 26px;
	text-align: center;
`;

//# sourceMappingURL=styled.js.map